import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Generate or get visitor ID from localStorage
const getVisitorId = () => {
  let visitorId = localStorage.getItem('visitor_id');
  if (!visitorId) {
    visitorId = 'v_' + Math.random().toString(36).substring(2, 15);
    localStorage.setItem('visitor_id', visitorId);
  }
  return visitorId;
};

const VisitorTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const trackVisit = async () => {
      try {
        await fetch(`${API_URL}/api/visitor-analytics/track`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            page: location.pathname,
            visitor_id: getVisitorId(),
            referrer: document.referrer || null,
            user_agent: navigator.userAgent
          }),
        });
      } catch (error) {
        // Silent fail - don't break the app for analytics
        console.debug('Analytics tracking failed:', error);
      }
    };

    trackVisit();
  }, [location.pathname]);

  return null; // This component doesn't render anything
};

export default VisitorTracker;
